import { render, staticRenderFns } from "./PageViewIcon.vue?vue&type=template&id=3a99c507&functional=true&"
var script = {}
import style0 from "./PageViewIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a99c507')) {
      api.createRecord('3a99c507', component.options)
    } else {
      api.rerender('3a99c507', component.options)
    }
    module.hot.accept("./PageViewIcon.vue?vue&type=template&id=3a99c507&functional=true&", function () {
      api.rerender('3a99c507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/PageViewIcon.vue"
export default component.exports